<script setup lang="ts">
import { EHubProvider } from '@/types/enum/HubProviderEnum'
import type { DetectionFilters } from '@/types/filters/DetectionFilters'
import type { DetectionModel } from '@/types/models/DetectionModel'
import type { AssociatedDeviceModel } from '@/types/models/DeviceModel'
import ViewerDeviceFilterAutocomplete from '@/views/DetectionsView/ViewerDeviceFilterAutocomplete.vue'
import { DeviceFilterAutocomplete } from '@rfc/rfc-components-library'
import {
    defaultQueryProvider,
    EProviders,
    type QueryProvider
} from '@rfc/rfc-components-library/types'
import { computed, inject } from 'vue'

const isViewerOnly = inject<boolean>(EHubProvider.IS_VIEWER_ONLY, false)
const { deviceQuery } = inject<QueryProvider>(EProviders.QUERY, defaultQueryProvider)

type Props = {
    filters: DetectionFilters
    deviceOptions?: AssociatedDeviceModel[]
    deviceFilters?: Record<string, unknown>
}

const props = defineProps<Props>()

type Emits = {
    (e: 'change', value: Partial<DetectionModel>): void
}
const emit = defineEmits<Emits>()

const handleSelectDevice = (value?: AssociatedDeviceModel) => {
    deviceQuery?.handleChangeDevice(value)
    emit('change', { device_id: value?.device_id ?? value?.id })
}

const computedFilters = computed(() => ({
    ...props.filters,
    device_id:
        !!deviceQuery?.device?.value?.device_id || !!deviceQuery?.device?.value?.id
            ? (deviceQuery?.device?.value?.device_id ?? deviceQuery?.device?.value?.id)
            : props.filters.device_id
}))
</script>

<template>
    <ViewerDeviceFilterAutocomplete
        v-if="isViewerOnly"
        :filters="computedFilters"
        :disabled="!deviceOptions"
        :deviceOptions="deviceOptions"
        @change="handleSelectDevice" />
    <DeviceFilterAutocomplete
        v-else
        :filters="computedFilters"
        :deviceFilters="deviceFilters"
        :deviceOptions="deviceOptions"
        @change="handleSelectDevice" />
</template>
